module.exports = __webpack_public_path__ + "img/jewels.5c2d8f4.svg";